import React, { useState } from 'react';
import { MenuIcon, XIcon, PhoneIcon } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="w-full bg-white shadow-md sticky top-0 z-50" data-id="element-100">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-101">
        <div className="hidden lg:flex items-center justify-between py-2 border-b border-gray-100" data-id="element-102">
          <div className="flex items-center space-x-4" data-id="element-103">
            <PhoneIcon className="h-4 w-4 text-red-600" data-id="element-104" />
            <span className="text-sm" data-id="element-105">
              Contact Fire Safety Displays For More Info
            </span>
          </div>
        </div>
        <div className="flex items-center justify-between py-4" data-id="element-106">
          <div className="flex items-center" data-id="element-107">
            <div className="text-2xl font-bold text-red-600 flex items-center" data-id="element-108">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rXt3UC7HbRPDJRZ11vHkeH/logo1.png" alt="Fire Safety Displays Logo" className="h-16 mr-2" data-id="element-109" />
            </div>
          </div>
          <nav className="hidden lg:flex items-center space-x-6" data-id="element-110">
            <a href="#" className="font-medium hover:text-red-600" data-id="element-111">
              HOME
            </a>
            <a href="#" className="font-medium hover:text-red-600" data-id="element-112">
              THE SYSTEM
            </a>
            <a href="#" className="font-medium hover:text-red-600" data-id="element-113">
              I.D. SIGN CATALOG
            </a>
            <a href="#" className="font-medium hover:text-red-600" data-id="element-114">
              SPECIALTY PROGRAMS
            </a>
            <a href="#" className="font-medium hover:text-red-600" data-id="element-115">
              CONTACT
            </a>
          </nav>
          <div className="flex items-center" data-id="element-116">
            <button className="lg:hidden p-2 rounded-full hover:bg-gray-100" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-117">
              {isMenuOpen ? <XIcon className="h-6 w-6" data-id="element-118" /> : <MenuIcon className="h-6 w-6" data-id="element-119" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="lg:hidden px-4 pt-2 pb-6 space-y-2 bg-white border-b border-gray-200" data-id="element-120">
          <a href="#" className="block py-2 font-medium" data-id="element-121">
            HOME
          </a>
          <a href="#" className="block py-2 font-medium" data-id="element-122">
            THE SYSTEM
          </a>
          <div className="pl-4" data-id="element-123">
            <a href="#" className="block py-1 text-sm" data-id="element-124">
              Evacuation Displays
            </a>
            <a href="#" className="block py-1 text-sm" data-id="element-125">
              I.D. Signs
            </a>
            <a href="#" className="block py-1 text-sm" data-id="element-126">
              Employee Pamphlets
            </a>
            <a href="#" className="block py-1 text-sm" data-id="element-127">
              Fire Department Information
            </a>
          </div>
          <a href="#" className="block py-2 font-medium" data-id="element-128">
            I.D. SIGN CATALOG
          </a>
          <div className="pl-4" data-id="element-129">
            <a href="#" className="block py-1 text-sm" data-id="element-130">
              Fire Signs
            </a>
            <a href="#" className="block py-1 text-sm" data-id="element-131">
              Exit Signs
            </a>
            <a href="#" className="block py-1 text-sm" data-id="element-132">
              Safety Signs
            </a>
            <a href="#" className="block py-1 text-sm" data-id="element-133">
              OSHA Safety Signs
            </a>
            <a href="#" className="block py-1 text-sm" data-id="element-134">
              Miscellaneous Signs
            </a>
          </div>
          <a href="#" className="block py-2 font-medium" data-id="element-135">
            SPECIALTY PROGRAMS
          </a>
          <div className="pl-4" data-id="element-136">
            <a href="#" className="block py-1 text-sm" data-id="element-137">
              Perimeter Security
            </a>
            <a href="#" className="block py-1 text-sm" data-id="element-138">
              Site Access
            </a>
            <a href="#" className="block py-1 text-sm" data-id="element-139">
              Pedestrian and Vehicle Safety
            </a>
            <a href="#" className="block py-1 text-sm" data-id="element-140">
              Visitor Safety Cards
            </a>
            <a href="#" className="block py-1 text-sm" data-id="element-141">
              E.R.T. Logos and Decals
            </a>
          </div>
          <a href="#" className="block py-2 font-medium" data-id="element-142">
            CONTACT
          </a>
        </div>}
    </header>;
}